"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExLink = void 0;
var Bytes_1 = require("../../Bytes");
var ExLink = /** @class */ (function () {
    function ExLink(type, seqNo, flags, value1, value2, memo) {
        if (flags === void 0) { flags = 0; }
        if (value1 === void 0) { value1 = 0; }
        if (value2 === void 0) { value2 = 0; }
        this.type = type;
        this.flags = flags ? flags : 0;
        this.value_1 = value1 ? value1 : 0;
        this.value_2 = value2 ? value2 : 0;
        this.memo = memo ? memo : undefined;
        if (this.type === ExLink.TYPE_AUTHOR) {
            this.link = Number(seqNo);
            if (isNaN(this.link)) {
                throw new Error('ID Person not number');
            }
        }
        else {
            var s = seqNo.split('-');
            if (s.length === 2 && !isNaN(Number(s[0])) && !isNaN(Number(s[1]))) {
                var seq = Number(s[0]);
                var no = Number(s[1]);
                var aSeq = Bytes_1.Bytes.syncIntToByteArray(seq);
                var aNo = Bytes_1.Bytes.syncIntToByteArray(no);
                var aLink = new Int8Array([aSeq[0], aSeq[1], aSeq[2], aSeq[3], aNo[0], aNo[1], aNo[2], aNo[3]]);
                this.link = Bytes_1.Bytes.syncLongFromByteArray(aLink);
                // console.log("test.exLink", {
                //     aSeq,
                //     aNo,
                //     aLink,
                //     link: this.link,
                // });
            }
            else {
                throw new Error('Error format SeqNo');
            }
        }
    }
    ExLink.TYPE_NONE = 0;
    ExLink.TYPE_APPENDIX = 1;
    ExLink.TYPE_REPLY_COMMENT = 2;
    ExLink.TYPE_SURELY = 5;
    ExLink.TYPE_SOURCE = 6;
    ExLink.TYPE_AUTHOR = 7;
    return ExLink;
}());
exports.ExLink = ExLink;
